import * as React from "react";
const SvgExport = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Export">
    <path
      fill="currentColor"
      d="M202.61 183.81v22.25c0 4.14-3.36 7.5-7.5 7.5H61.53c-4.14 0-7.5-3.36-7.5-7.5v-22.25c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5v29.24c0 8.56 6.94 15.5 15.5 15.5H202.1c8.56 0 15.5-6.94 15.5-15.5v-29.24c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5Z"
    />
    <path
      fill="currentColor"
      d="M120.83 78.42v100.91c0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5V78.44l50.95 50.96a7.502 7.502 0 1 0 10.61-10.61l-63.77-63.77a7.5 7.5 0 0 0-10.61 0l-63.77 63.77a7.502 7.502 0 1 0 10.61 10.61l50.97-50.97Z"
    />
  </svg>
);
export default SvgExport;
